import Flickity from 'flickity';
import 'flickity/dist/flickity.min.css';

/**
 * Room Card Carousel Component
 * Handles the carousel for individual room cards on the Rooms archive page
 */
export default class RoomCardCarousel {
  constructor(element) {
    this.element = element;
    this.carousel = element.querySelector('[data-room-card-carousel]');
    
    if (!this.carousel) {
      console.warn('Room card carousel element not found');
      return;
    }
    
    // Navigation elements - search from the parent card element
    const card = element.closest('.rooms-archive__card');
    this.prevBtn = card.querySelector('.rooms-archive__card-arrow--prev');
    this.nextBtn = card.querySelector('.rooms-archive__card-arrow--next');
    this.currentCounter = card.querySelector('.current-slide');
    this.totalCounter = card.querySelector('.total-slides');
    
    this.flickity = null;
    
    this.init();
  }

  init() {
    // Check if there are any slides
    const slides = this.carousel.querySelectorAll('.rooms-archive__card-slide');
    
    if (slides.length === 0) {
      console.warn('No slides found in room card carousel');
      return;
    }
    
    // Initialize Flickity
    this.flickity = new Flickity(this.carousel, {
      cellAlign: 'left',
      cellSelector: '.rooms-archive__card-slide',
      contain: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      adaptiveHeight: false,
      imagesLoaded: true,
      selectedAttraction: 0.1,
      friction: 0.8,
    });
    
    // Bind custom controls
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.flickity.previous();
      });
    }
    
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.flickity.next();
      });
    }
    
    // Update counter on change
    this.flickity.on('change', (index) => {
      this.updateCounter(index);
    });
    
    // Initialize counter
    this.updateCounter(0);
  }
  
  updateCounter(index) {
    if (this.currentCounter) {
      this.currentCounter.textContent = index + 1;
    }
  }
  
  destroy() {
    if (this.flickity) {
      this.flickity.destroy();
    }
  }
}
